import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { useRouter } from "next/router";

const PaymentFailed = ({ handleClose, errorMessage }) => {
    const router = useRouter();
    const [num, setNum] = useState(3);


    useEffect(() => {
        const interval = setInterval(() => {
            setNum((prevNum) => {
                if (prevNum > 1) {
                    return prevNum - 1; // Reduce countdown
                } else {
                    clearInterval(interval); // Stop interval when num reaches 1
                    handleClose(); // Call your close function
                    return 1;
                }
            });
        }, 1000);

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    return (
        <Container
            maxWidth="sm"
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                // height: "100vh",
            }}
        >
            <Box
                sx={{
                    // backgroundColor: "white",
                    padding: "30px",
                    // borderRadius: "10px",
                    // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    textAlign: "center",
                }}
            >
                {/* Payment Failed Icon */}
                <CancelIcon sx={{ fontSize: 60, color: "red", marginBottom: "10px" }} />

                {/* Payment Failed Title */}
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Error processing transaction
                </Typography>

                {/* Error Message */}
                <Typography variant="body1" color="textSecondary" paragraph>
                    {
                        errorMessage?.message ? errorMessage?.message : (
                            <div>
                                There was a problem with the card you provided.
                                <br />
                                Please contact your card issuer for further assistance.
                            </div>
                        )
                    }

                </Typography>

                {/* Transaction Number */}
                {/* <Typography variant="body2" fontWeight="bold" mt={2}>
                    Transaction No.
                </Typography> */}

                {/* Back to Merchant Button */}
                <Button
                    variant="text"
                    color="success"
                    sx={{ mt: 2, textTransform: "none", fontWeight: "bold", border: "1px solid" }}
                    onClick={handleClose}
                >
                    Back
                </Button>

                {/* Auto Redirect Message */}
                <Typography variant="body2" color="textSecondary" mt={1}>
                    You will be redirected to the merchant site after {num}s.
                </Typography>
            </Box>
        </Container>
    );
};

export default PaymentFailed;
